// Letting a held pool go: the one door, in one place.
//
// POST /warmup/pools/{code}/release (UI-6) decides server-side which hold is
// on the pool — the watch's (paused, throttled) or the warmup's own stop on
// the day's figures — and lets that one go. So a pool the warmup stopped is
// offered the button before the watch catches up with it (within the hour),
// and a watch that moved between the page's read and the click is not a 409.
// The dialog speaks from the pool's warmup card, in the Warmup page's words:
// a release the scheduler would undo within the minute says so here too.

import { fetchWarmupPool, releaseWarmupPool } from "@/lib/api";
import type { PoolWatchRow, WarmupPool } from "@/lib/api";

export async function releaseHeldPool(pool: string, note: string): Promise<void> {
  await releaseWarmupPool(pool, note);
}

/** The pool's warmup card: what a release will do, and whether it will hold. */
export function releaseCard(pool: string): Promise<WarmupPool> {
  return fetchWarmupPool(pool);
}

/** Whether the door can open this pool: the watch holds it, or the warmup does. */
export function canRelease(row: PoolWatchRow): boolean {
  return row.state === "paused" || row.state === "throttled" || row.is_paused;
}

/** Stopped by the warmup, not (yet) by the watch. */
export function heldByWarmupOnly(row: PoolWatchRow): boolean {
  return row.is_paused && row.state !== "paused" && row.state !== "throttled";
}
